import { PlusIcon } from "@heroicons/react/20/solid"
import { InfoTooltip } from "../../../components/general/InfoTooltip.tsx"
import Switch from "../../../components/general/Switch.tsx"

const netAmountLockTooltipText =
    "Aan: het nettobedrag blijft vast bij een ander BTW-tarief; BTW wordt herberekend. Uit: netto en BTW worden opnieuw uit het regeltotaal verdeeld."

const TOOLBAR_BUTTON =
    "inline-flex h-8 items-center gap-1.5 rounded-md border border-gray-300 bg-white px-2.5 text-[12px] font-semibold text-gray-700 shadow-sm transition-colors hover:border-primary hover:bg-primary/[0.03] hover:text-darkprimary focus:outline-none focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50"

type TableActionsProps = {
    canBookDocument: boolean
    lineItemIds: string[]

    handleAddRow: () => void
    setIsBulkActionsOpen: (open: boolean) => void
    isNetAmountLocked: boolean
    onNetAmountLockedChange: (isNetAmountLocked: boolean) => void
}

export function TableActions({
    canBookDocument,
    lineItemIds,

    handleAddRow,
    setIsBulkActionsOpen,
    isNetAmountLocked,
    onNetAmountLockedChange,
}: TableActionsProps) {

    return (
        <div className="flex flex-wrap items-center justify-end gap-2">
            <div className="mr-0.5 inline-flex h-8 items-center gap-1.5 rounded-md border border-transparent px-1.5 text-[12px] text-gray-600">
                <span className="whitespace-nowrap">Excl. bedrag vast</span>
                <InfoTooltip position="top" text={netAmountLockTooltipText} />
                <Switch
                    checked={isNetAmountLocked}
                    onChange={onNetAmountLockedChange}
                    aria-label="Excl. bedrag vergrendelen"
                />
            </div>
            {canBookDocument && lineItemIds.length > 0 && (
                <button
                    type="button"
                    className={TOOLBAR_BUTTON}
                    onClick={() => setIsBulkActionsOpen(true)}
                    title="Meerdere regels tegelijk aanpassen"
                >
                    Bulk acties
                </button>
            )}
            <button type="button" className={TOOLBAR_BUTTON} onClick={handleAddRow} title="Nieuwe boekingsregel toevoegen">
                <PlusIcon className="h-4 w-4" aria-hidden="true" />
                Regel toevoegen
            </button>
        </div>
    )
}
